import { render, staticRenderFns } from "./ServiceOrderList.vue?vue&type=template&id=18b695bc&scoped=true&"
import script from "./ServiceOrderList.vue?vue&type=script&lang=js&"
export * from "./ServiceOrderList.vue?vue&type=script&lang=js&"
import style0 from "./ServiceOrderList.vue?vue&type=style&index=0&id=18b695bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b695bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18b695bc')) {
      api.createRecord('18b695bc', component.options)
    } else {
      api.reload('18b695bc', component.options)
    }
    module.hot.accept("./ServiceOrderList.vue?vue&type=template&id=18b695bc&scoped=true&", function () {
      api.rerender('18b695bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/services/order/ServiceOrderList.vue"
export default component.exports